// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"163":"358ee058","215":"3779a9c9","645":"39f1ac5c","787":"f1cccb18"}[chunkId] + ".chunk.js";
};